<template>
  <div class="client-contact-email-body">
    <div class="choose-event-wrapper row">
      <div class="col-md-3">
        <div class="h3-text">Event Type</div>
        <div class="select-type-event">
          <pretty-radio name="isSingleEvent" class="custom-radio-btn p-default p-round text-label" v-model="isSingleEvent" :value="true">This single event</pretty-radio>
          <pretty-radio name="isSingleEvent" class="custom-radio-btn p-default p-round text-label" v-model="isSingleEvent" :value="false">Related Events <span v-if="event.relatedEvents.length > 0" class="event-count">({{event.relatedEvents.length}})</span></pretty-radio>
        </div>
      </div>
      <div class="col-md-9">
        <div class="h3-text">Events</div>
        <div class="group-related-events">
          <div v-if="isSingleEvent == true" class="related-event-item">
            <div class="event-name" @click="relatedEventItemClick(event.id)">{{event.eventName}}</div>
          </div>
          <div v-else v-for="reEvent in event.relatedEvents" :key="reEvent.id" class="related-event-item">
            <div class="event-name" @click="relatedEventItemClick(reEvent.id)">{{reEvent.eventName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="recipients-wrapper row">
      <div class="recipients-section col-md-6">
        <div class="h3-text text-mar-bot">Recipients</div>
        <div class="list-email-recipient">
          <div class="ap-input-wrapper">
            <input type="text" v-on:keyup.enter="addRecipientTo" class="ap-input" placeholder="Enter email address" v-model="recipientEmail"/>
            <div class="add-icon" @click="addRecipientTo"></div>
          </div>
          <div class="list-email-send-to">
            <div v-for="e in listEmailSendTo" :key="e" class="email-item">
              <div class="text">{{e}}</div>
              <div class="remove-icon" @click="removeRecipient(e)"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cc-section col-md-6">
        <div class="h3-text text-mar-bot">Additional Recipients (CC)</div>
        <div class="list-email-recipient">
          <div class="ap-input-wrapper">
            <input type="text" v-on:keyup.enter="addRecipientCC" class="ap-input" placeholder="Enter email address" v-model="ccEmail"/>
            <div class="add-icon" @click="addRecipientCC"></div>
          </div>
          <div class="list-email-send-to">
            <div v-for="e in listEmailCC" :key="e" class="email-item">
              <div class="text">{{e}}</div>
              <div class="remove-icon" @click="removeRecipientCC(e)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="h3-text text-send-email">Send Email</p>
    <div class="send-email-container">
      <div class="col-6 participant-emails">
        <div class="text-entry-field-wrapper w-100">
          <span class="text-entry-title">Email Template</span>
          <multiselect
                        v-model="emailTemplate"
                        :options="emailTemplates"
                        placeholder="Choose Email Type"
                        label="templateTypeName"
                        class="multiple-select-work-group"
                        :openDirection="'below'"
                        @select="onSelectEmailTemplate"
                        :allow-empty="false"
                        :show-labels="false"
                        >
          </multiselect>
        </div>
        <div class="text-entry-field-wrapper mt-3 w-100">
          <span class="text-entry-title">Subject Line</span>
          <input type="text" placeholder="Enter email subject line" class="text-subject" v-model="emailTemplate.emailSubject"/>
        </div>
        <div class="text-entry-field-wrapper mt-3">
          <span class="text-entry-title">Email body</span>
          <vue-ckeditor
            v-model="emailTemplate.body"
            :config="config"
            @input="onChangeTemplate"></vue-ckeditor>
        </div>
      </div>
      <div class="col-6">
        <div class="email-template-wrapper">
          <div class="reply-and-history-section w-100">
            <div class="reply-emails-wrapper">
              <div class="text-entry-title">Reply emails go to:</div>
              <div class="list-email-recipient">
                <div class="ap-input-wrapper">
                  <input type="text" v-on:keyup.enter="addReplyEmailGoTo" class="ap-input" placeholder="Enter email address" v-model="replyEmail"/>
                  <div class="add-icon" @click="addReplyEmailGoTo"></div>
                </div>
                <div class="list-email-send-to">
                  <div class="email-item" v-if="listReplyEmails != ''">
                    <div class="text">{{listReplyEmails}}</div>
                    <div class="remove-icon" @click="removeRecipientReply(listReplyEmails)"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="email-history-wrapper">
              <div class="email-history-text-wrapper">
                <div class="email-history-text text-entry-title">Email History</div>
              </div>
              <div class="list-email-recipient">
                <div class="email-history-title col-md-12">
                  <div class="row">
                    <div class="caption-text sent-date col-md-5" @click="setSortOption('time')">Sent Date
                      <Icon name="sort" class="sort-icon"></Icon>
                    </div>
                    <div class="line"></div>
                    <div class="caption-text email-template col-md-5" @click="setSortOption('template')">Email Template
                      <Icon name="sort" class="sort-icon"></Icon>
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
                <div class="list-email-send-to">
                  <div class="history-item" v-for="h in listHistory" :key="h">
                    <div class="history-left">
                      <div class="sent-date">{{h.time | dateFormatMMDDYY }}</div>
                      <div class="email-template">{{h.template | templateName}}</div>
                    </div>
                    <div class="view-detail" @click="goToEmailHistoryDetails(h.id)">View details</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-container">
      <b-button class="btn-cancel" @click="onCancel">
        Cancel
      </b-button>
      <b-button class="btn-send" :disabled="isSendLoading" @click="sendEmailClick">
        <b-spinner variant="primary" v-if="isSendLoading"></b-spinner>
        Send
      </b-button>
    </div>
    <ModalChangeEmailTemplate @CLOSE_MODAL_CHANGE_TEMPLATE_ACTION="closeModalChangeMailTemplate"/>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import Icon from 'vue-awesome/components/Icon';
  import PrettyRadio from 'pretty-checkbox-vue/radio';
  import emailTemplateConsts from '@/store/constants/emailTemplateType';
  import VueCkeditor from 'vue-ckeditor2';
  import ModalChangeEmailTemplate from '@/components/modal/ModalChangeEmailTemplate';
  import consts from '@/_consts';
  import 'vue-awesome/icons/sort';
  import arrHelper from '@/utils/array-helper';
  import Vue from 'vue';
  import iziToastOptions from '../../utils/izi-toast';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'client-contact-email-body',
    components: {
      Icon,
      PrettyRadio,
      VueCkeditor,
      ModalChangeEmailTemplate,
      Multiselect
    },
    data () {
      return {
        reg: new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'),
        listEmailCC: [],
        listEmailSendTo: [],
        listReplyEmails: '',
        listHistory: [],
        replyEmail: '',
        ccEmail: '',
        recipientEmail: '',
        selectedTemplate: emailTemplateConsts.day60,
        emailTemplates: [],
        emailTemplateConsts: emailTemplateConsts,
        body: '',
        isSingleEvent: true,
        config: {
          toolbar: [
            { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
            { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'links', items: [ 'Link', 'Unlink' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'insert', items: [ 'Image', 'Table' ] },
            { name: 'tools', items: [ 'Maximize' ] },
            { name: 'editing', items: [ 'Scayt' ] },
            { name: 'document', items: ['Source'] }
          ],
          height: 220,
          allowedContent: true
        },
        isChangedEditor: false,
        selectedTemplateOldValue: emailTemplateConsts.day60,
        sortReverse: false,
        emailTemplate: {
          body: '',
          emailSubject: '',
          templateType: ''
        },
        isSendLoading: false
      };
    },
    computed: {
    },
    filters: {
    },
    props: {
      event: {
        type: Object,
        default: {}
      },
      eventId: {
        type: Number
      },
      isChange: {
        type: Boolean
      },
      cancelClick: {
        type: Function
      },
      backToPreviousPage: {
        type: Function
      }
    },
    methods: {
      setSortOption (field) {
        this.sortReverse = !this.sortReverse;
        this.listHistory.sort(arrHelper.sortFunction(field, this.sortReverse));
      },
      closeModalChangeMailTemplate (changeTemplate) {
        if (changeTemplate) {
          this.setSelectedTemplate();
          this.isChangedEditor = false;
        } else {
          this.selectedTemplate = this.selectedTemplateOldValue;
        }
      },
      relatedEventItemClick (eventId) {
        this.$modal.hide('eventDetailModal');
        this.$modal.show('eventDetailModal', { eventId: eventId });
        this.updateNextZIndex('eventDetailModal');
      },
      addReplyEmailGoTo () {
        if (this.replyEmail === '' || !this.isValidEmail(this.replyEmail)) {
          Vue.prototype.$toast.success('Invalid email', '', {
            ...iziToastOptions.optError
          });
          return;
        }
        this.listReplyEmails = this.replyEmail;
        this.replyEmail = '';
      },
      addRecipientTo () {
        if (this.recipientEmail === '' || !this.isValidEmail(this.recipientEmail)) {
          Vue.prototype.$toast.success('Invalid email', '', {
            ...iziToastOptions.optError
          });
          return;
        }
        let index = this.listEmailSendTo.indexOf(this.recipientEmail);
        if (index < 0) {
          // verify valid email
          this.listEmailSendTo.push(this.recipientEmail);
          this.recipientEmail = '';
        } else {
          Vue.prototype.$toast.success('The email already exist', '', {
            ...iziToastOptions.optError
          });
        }
      },
      addRecipientCC () {
        if (this.ccEmail === '' || !this.isValidEmail(this.ccEmail)) {
          Vue.prototype.$toast.success('Invalid email', '', {
            ...iziToastOptions.optError
          });
          return;
        }
        let index = this.listEmailCC.indexOf(this.ccEmail);
        if (index < 0) {
          this.listEmailCC.push(this.ccEmail);
          this.ccEmail = '';
        } else {
          Vue.prototype.$toast.success('The email already exist', '', {
            ...iziToastOptions.optError
          });
        }
      },
      ckEditorFocus (e) {
        this.isChangedEditor = true;
        this.$bus.$emit('changeEditor');
      },
      getEmailTemplate (isSingleEvent, isDefault) {
        this.getDefaultEmailTemplate({
          eventId: this.eventId || this.$route.params.eventId,
          isSingleEvent: isSingleEvent
        }).then((response) => {
          this.emailTemplates = response.templates;
          this.emailTemplate = this.emailTemplates[0];
          if (isDefault) {
            this.selectedTemplate = emailTemplateConsts.day60;
          }
          this.setSelectedTemplate(isSingleEvent, false);
        });
      },
      setSelectedTemplate () {
        if (this.selectedTemplate === emailTemplateConsts.day60) {
          this.body = this.emailTemplates[0].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.day30) {
          this.body = this.emailTemplates[1].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.day7) {
          this.body = this.emailTemplates[2].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.thankyou) {
          this.body = this.emailTemplates[3].body;
        }
        this.selectedTemplateOldValue = this.selectedTemplate;
      },
      removeRecipientReply (email) {
        let index = this.listReplyEmails.indexOf(email);
        if (index >= 0) {
          this.listReplyEmails = '';
        }
      },
      removeRecipient (email) {
        let index = this.listEmailSendTo.indexOf(email);
        if (index >= 0) {
          this.listEmailSendTo.splice(index, 1);
        }
      },
      removeRecipientCC (email) {
        let index = this.listEmailCC.indexOf(email);
        if (index >= 0) {
          this.listEmailCC.splice(index, 1);
        }
      },
      goToEmailHistoryDetails (id) {
        // GO to email detail
        this.$router.push({name: 'EmailHistoryDetailsManagement',
          params: {
            id: id,
            eventId: this.eventId
          }
        });
      },
      isValidEmail (email) {
        return email && email.length && this.reg.test(String(email).toLowerCase());
      },
      viewAllMailHistories () {
        this.$router.push({name: 'EmailHistoriesManagement', params: {eventId: this.eventId}});
      },
      onCancel () {
        this.cancelClick();
      },
      onSelectEmailTemplate (item) {
        this.emailTemplate = item;
      },
      addEmailToList (email, list) {
        if (this.isValidEmail(email) && list.indexOf(email) < 0) {
          list.push(email);
        }
      },
      addEventEmailsToList (event, list) {
        this.addEmailToList(event.email, list);
        this.addEmailToList(event.secondEmail, list);
      },
      sendEmailClick () {
        this.isSendLoading = true;
        let params = {
          eventId: this.eventId,
          isSingleEvent: this.isSingleEvent,
          recipients: this.listEmailSendTo,
          additionalRecipients: this.listEmailCC,
          replyTo: this.listReplyEmails,
          emailTemplateType: this.emailTemplate.templateType,
          emailSubject: this.emailTemplate.emailSubject,
          body: this.emailTemplate.body
        };
        this.sendOnSiteContactEmail(params).then((response) => {
          this.isSendLoading = false;
          this.$toast.success('Email sent successfully!', '', {
            ...this.$toastOpt.optSuccess,
            onClosed: this.backToPreviousPage
          });
        });
      },
      ...mapActions({
        getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
        sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL',
        updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
      })
    },
    watch: {
      isSingleEvent: function (oldVal, newVal) {
        this.listEmailSendTo = [];
        this.addEventEmailsToList(this.event, this.listEmailSendTo);

        if (!this.isSingleEvent) {
          this.event.relatedEvents.forEach(element => {
            this.addEventEmailsToList(element, this.listEmailSendTo);
          });
        }
        this.getEmailTemplate(this.isSingleEvent, false);
      },
      'event.id': function () {
        this.event.relatedEvents.unshift(this.event);
        if (this.isSingleEvent) {
          this.listEmailSendTo = [];
          this.addEventEmailsToList(this.event, this.listEmailSendTo);
        } else {
          this.event.relatedEvents.forEach(element => {
            this.addEventEmailsToList(element, this.listEmailSendTo);
          });
        }

        if (this.event.emailHistories) {
          this.event.emailHistories.forEach(element => {
            this.listHistory.push({
              id: element.id,
              time: element.lastModifiedAt,
              template: element.templateType
            });
          })
        }
      },
      selectedTemplate: function (newVal, oldVal) {
        if (this.selectedTemplate === this.selectedTemplateOldValue && this.isChangedEditor) {
          return;
        }
        this.selectedTemplateOldValue = oldVal;
        if (!this.isChangedEditor) {
          this.setSelectedTemplate();
          return;
        }
        let modalData = {
          action: consts.modalAction.modalAlertChangeEmailTemplate,
          data: null
        };
        this.$modal.show('modalChangeEmailTemplate', modalData);
      }
    },
    created () {
    },
    mounted () {
      this.getEmailTemplate(true, true);
    }
  }
</script>


// WEBPACK FOOTER //
// ClientContactEmail.vue?6a597f20